<ui-object-navigation-main-page alias="cr"></ui-object-navigation-main-page>